(function () {
  if (window.NaomiJudgemeReviews && window.NaomiJudgemeReviews.initAll) {
    window.NaomiJudgemeReviews.initAll();
    return;
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normalize(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/[.!?]+$/g, "")
      .toLowerCase();
  }

  function escapeRegExp(value) {
    return String(value || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function flexibleTextPattern(value) {
    return String(value || "").trim().split(/\s+/).map(escapeRegExp).join("\\s+");
  }

  function trimRepeatedTitleFromBody(title, body) {
    var cleanTitle = String(title || "").replace(/\s+/g, " ").trim();
    var cleanBody = String(body || "").replace(/\s+/g, " ").trim();

    if (!normalize(cleanTitle) || !cleanBody) return { body: cleanBody, deduped: false };
    if (normalize(cleanTitle) === normalize(cleanBody)) return { body: "", deduped: true };

    var titlePrefix = new RegExp("^" + flexibleTextPattern(cleanTitle) + "[.!?:;,\\-–—]*\\s*", "i");
    var trimmedBody = cleanBody.replace(titlePrefix, "").trim();

    return {
      body: trimmedBody === cleanBody ? cleanBody : trimmedBody,
      deduped: trimmedBody !== cleanBody
    };
  }

  function startsMidSentence(value) {
    return /^[a-z]/.test(String(value || "").trim());
  }

  function numericText(value) {
    var match = String(value || "").match(/\d+(?:\.\d+)?/);
    return match ? match[0] : "";
  }

  function cleanToken(value) {
    var token = String(value || "").trim();
    if (!token || /PASTE|REPLACE|YOUR|TOKEN_HERE/i.test(token)) return "";
    return token;
  }

  function cleanReviewBody(value) {
    return String(value || "")
      .replace(/Review written in Shop App/gi, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalizeMediaUrl(value) {
    var url = String(value || "").trim();

    if (!url || /^data:/i.test(url)) return "";
    if (url.indexOf("//") === 0) return window.location.protocol + url;
    if (/^https?:\/\//i.test(url)) return url;
    if (url.charAt(0) === "/") return window.location.origin + url;

    return url;
  }

  function firstSrcsetUrl(value) {
    var candidate = String(value || "").split(",")[0] || "";

    return candidate.trim().split(/\s+/)[0] || "";
  }

  function mediaWidthHint(value) {
    var match = String(value || "").match(/[?&]width=(\d+)/i);

    return match ? Number(match[1]) : 0;
  }

  function addReviewPhoto(photos, src, alt) {
    var normalized = normalizeMediaUrl(src);
    var key = normalized.replace(/[?#].*$/, "");
    var existing;

    if (!normalized) return;

    existing = photos.filter(function (photo) { return photo.key === key; })[0];
    if (existing) {
      if (mediaWidthHint(normalized) > mediaWidthHint(existing.src) || (!mediaWidthHint(normalized) && mediaWidthHint(existing.src))) {
        existing.src = normalized;
      }
      if (!existing.alt && alt) existing.alt = alt;
      return;
    }

    photos.push({
      alt: alt || "Review photo",
      key: key,
      src: normalized
    });
  }

  function readReviewPhotos(review) {
    var photos = [];

    Array.prototype.slice.call(review.querySelectorAll(".jdgm-rev__pics img, .jdgm-rev__pic img, .jdgm-rev__pic-img, img[class*='pic'], img[class*='photo']")).forEach(function (image) {
      addReviewPhoto(
        photos,
        image.getAttribute("src") ||
          image.getAttribute("data-src") ||
          image.getAttribute("data-original") ||
          image.getAttribute("data-lazy-src") ||
          firstSrcsetUrl(image.getAttribute("srcset") || image.getAttribute("data-srcset")),
        image.getAttribute("alt")
      );
    });

    Array.prototype.slice.call(review.querySelectorAll(".jdgm-rev__pic-link, .jdgm-rev__pic, [data-mfp-src], [data-src][class*='pic'], [style*='background']")).forEach(function (node) {
      var style = node.getAttribute("style") || "";
      var backgroundMatch = style.match(/url\((['"]?)(.*?)\1\)/i);

      addReviewPhoto(
        photos,
        node.getAttribute("data-mfp-src") ||
          node.getAttribute("href") ||
          node.getAttribute("data-original") ||
          node.getAttribute("data-src") ||
          (backgroundMatch && backgroundMatch[2]),
        node.getAttribute("aria-label") || node.getAttribute("title")
      );
    });

    return photos.slice(0, 4);
  }

  function cleanProductTitle(value) {
    var title = String(value || "")
      .replace(/^product\s*(reviewed)?\s*:?\s*/i, "")
      .replace(/\s+/g, " ")
      .trim();

    if (!title || /^(verified|united states)$/i.test(title)) return "";
    return title;
  }

  function cleanDate(value) {
    var date = String(value || "")
      .replace(/\s+/g, " ")
      .trim();
    var ymd = date.match(/\b(\d{4})-(\d{2})-(\d{2})\b/);

    if (ymd) return Number(ymd[2]) + "/" + Number(ymd[3]) + "/" + ymd[1];

    return date.replace(/\s+UTC$/i, "");
  }

  function initialsFromName(value) {
    var words = String(value || "Anonymous")
      .replace(/[^a-zA-Z0-9\s-]/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .split(" ")
      .filter(Boolean);

    if (!words.length) return "A";
    if (words.length === 1) return words[0].charAt(0).toUpperCase();

    return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
  }

  function isAnonymousAuthor(value) {
    return /^anonymous$/i.test(String(value || "").trim());
  }

  function text(selector, parent) {
    var node = parent && parent.querySelector(selector);
    return node ? node.textContent.replace(/\s+/g, " ").trim() : "";
  }

  function isExplicitlyHidden(element) {
    var style = (element.getAttribute("style") || "").replace(/\s/g, "").toLowerCase();
    return element.hidden || element.getAttribute("aria-hidden") === "true" || style.indexOf("display:none") !== -1 || style.indexOf("visibility:hidden") !== -1;
  }

  function isVerifiedReview(review) {
    var buyerBadgeWrapper = review.querySelector(".jdgm-rev__buyer-badge-wrapper");
    var buyerBadgeText = text(".jdgm-rev__buyer-badge", review) || text(".jdgm-rev__buyer-badge-wrapper", review);
    var verifiedAsset = review.querySelector(".jdgm-rev__verification-badge-img[alt*='Verified' i], [aria-label*='Verified' i], [title*='Verified' i], [class*='verification-badge']");

    return (buyerBadgeWrapper && !isExplicitlyHidden(buyerBadgeWrapper)) || /verified/i.test(buyerBadgeText) || Boolean(verifiedAsset);
  }

  function reviewDate(review) {
    var timestamp = review.querySelector(".jdgm-rev__timestamp");

    if (!timestamp) return "";

    return cleanDate(
      timestamp.textContent ||
      timestamp.getAttribute("data-content") ||
      timestamp.getAttribute("datetime") ||
      timestamp.getAttribute("title") ||
      timestamp.getAttribute("aria-label")
    );
  }

  function starsHtml(rating) {
    var active = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    var html = "";

    for (var index = 1; index <= 5; index += 1) {
      html += '<span class="naomi-reviews__star' + (index <= active ? " is-active" : "") + '">★</span>';
    }

    return html;
  }

  function reviewRating(review) {
    var rating = review.querySelector(".jdgm-rev__rating");
    var score = rating && (rating.getAttribute("data-score") || rating.getAttribute("data-rating"));
    var label;
    var match;

    if (score) return Number(score);

    label = rating && (rating.getAttribute("aria-label") || rating.getAttribute("title") || "");
    match = label.match(/([1-5])(?:\.\d+)?/);
    if (match) return Number(match[1]);

    return review.querySelectorAll(".jdgm-rev__rating .jdgm--on").length || 5;
  }

  function readHistogram(parent) {
    var rows = Array.prototype.slice.call(parent.querySelectorAll(".jdgm-histogram__row[data-rating]"));
    var byRating = {};

    rows
      .filter(function (row) {
        return row.getAttribute("data-rating") && row.getAttribute("data-rating") !== "null";
      })
      .forEach(function (row) {
        var rating = Number(row.getAttribute("data-rating"));
        var frequencyNode = row.querySelector(".jdgm-histogram__frequency");
        var frequency = frequencyNode ? frequencyNode.textContent.replace(/\D/g, "") : row.getAttribute("data-frequency");
        var percentage = row.getAttribute("data-percentage");
        var fill = row.querySelector(".jdgm-histogram__bar-content");
        var width = percentage ? percentage + "%" : fill && fill.style.width ? fill.style.width : "0%";
        var item = {
          rating: rating,
          count: frequency || "0",
          width: width
        };

        if (!byRating[rating] || Number(item.count) >= Number(byRating[rating].count)) {
          byRating[rating] = item;
        }
      });

    return Object.keys(byRating)
      .map(function (rating) {
        return byRating[rating];
      })
      .sort(function (a, b) {
        return b.rating - a.rating;
      });
  }

  function readReviews(parent, filterRating) {
    var seen = {};

    return Array.prototype.slice.call(parent.querySelectorAll(".jdgm-rev")).map(function (review, index) {
      var title = text(".jdgm-rev__title", review);
      var body = cleanReviewBody(text(".jdgm-rev__body", review));
      var dedupedReview = trimRepeatedTitleFromBody(title, body);
      var titleOnlyBody = !normalize(title) && body && body.length <= 140;
      var titleLooksGenerated = dedupedReview.deduped && dedupedReview.body && startsMidSentence(dedupedReview.body);
      var productTitle = cleanProductTitle(
        review.getAttribute("data-product-title") ||
        text(".jdgm-rev__product-title", review) ||
        text(".jdgm-rev__prod-title", review) ||
        text(".jdgm-rev__product-name", review) ||
        text(".jdgm-rev__prod-name", review) ||
        text(".jdgm-row-product", review)
      );

      return {
        author: text(".jdgm-rev__author", review) || "Anonymous",
        rating: reviewRating(review),
        date: reviewDate(review),
        index: index,
        productTitle: productTitle,
        title: titleLooksGenerated ? "" : title || (titleOnlyBody ? body : ""),
        body: titleLooksGenerated ? body : titleOnlyBody ? "" : dedupedReview.body,
        dedupedBody: dedupedReview.deduped,
        photos: readReviewPhotos(review),
        verified: isVerifiedReview(review)
      };
    }).filter(function (review) {
      var key = reviewKey(review);

      if (filterRating !== null && review.rating !== filterRating) return false;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function reviewKey(review) {
    return [review.author, review.rating, review.date, review.productTitle, review.title, review.body].map(normalize).join("|");
  }

  function mergeReviews(current, incoming) {
    var seen = {};
    var merged = [];

    current.concat(incoming).forEach(function (review) {
      var key = reviewKey(review);
      if (seen[key]) return;
      seen[key] = true;
      review.index = merged.length;
      merged.push(review);
    });

    return merged;
  }

  function totalFromHistogram(histogram, rating) {
    if (rating !== null) {
      return histogram.reduce(function (sum, item) {
        return item.rating === rating ? sum + (Number(item.count) || 0) : sum;
      }, 0);
    }

    return histogram.reduce(function (sum, item) {
      return sum + (Number(item.count) || 0);
    }, 0);
  }

  function averageFromHistogram(histogram) {
    var total = 0;
    var weighted = 0;

    histogram.forEach(function (item) {
      var count = Number(item.count) || 0;
      total += count;
      weighted += item.rating * count;
    });

    return total ? (weighted / total).toFixed(2) : "";
  }

  function parseApiHtml(responseText) {
    var parsed;
    var candidates;

    try {
      parsed = JSON.parse(responseText);
    } catch (error) {
      return responseText;
    }

    candidates = [
      parsed && parsed.widget,
      parsed && parsed.html,
      parsed && parsed.product_review,
      parsed && parsed.review_widget,
      parsed && parsed.body,
      parsed && parsed.data && parsed.data.widget,
      parsed && parsed.data && parsed.data.html,
      parsed && parsed.data && parsed.data.product_review,
      parsed && parsed.data && parsed.data.review_widget
    ];

    for (var index = 0; index < candidates.length; index += 1) {
      if (typeof candidates[index] === "string" && candidates[index].trim()) {
        return candidates[index];
      }
    }

    return responseText;
  }

  function parseWidget(html, filterRating) {
    var documentNode = new DOMParser().parseFromString(parseApiHtml(html), "text/html");
    var widget = documentNode.querySelector(".jdgm-rev-widg") || documentNode.querySelector(".jdgm-widget") || documentNode.body;
    var average = numericText(text(".jdgm-rev-widg__summary-average", widget)) || numericText(text(".jdgm-link", widget));
    var histogram = readHistogram(widget);
    var reviews = readReviews(widget, filterRating);
    var hasMore = Boolean(widget.querySelector(".jdgm-paginate__load-more, .jdgm-paginate__next-page, a[rel='next'], .jdgm-paginate a[href*='page=']"));

    if (!average) average = averageFromHistogram(histogram);

    return {
      average: average,
      histogram: histogram,
      reviews: reviews,
      hasMore: hasMore
    };
  }

  function unique(values) {
    var seen = {};
    return values.filter(function (value) {
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    });
  }

  function encodeQuery(params) {
    return Object.keys(params)
      .filter(function (key) {
        return params[key] !== undefined && params[key] !== null && params[key] !== "";
      })
      .map(function (key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
      })
      .join("&");
  }

  function initReviews(root) {
    if (root.getAttribute("data-naomi-reviews-ready") === "true") return;
    root.setAttribute("data-naomi-reviews-ready", "true");

    var source = root.querySelector("#naomi_judgeme_product_reviews_source");
    var sourceWrap = root.querySelector("[data-naomi-reviews-source]");
    var view = root.querySelector("[data-naomi-reviews-view]");
    var empty = root.querySelector("[data-naomi-reviews-empty]");
    var averageTarget = root.querySelector("[data-naomi-reviews-average]");
    var starsTarget = root.querySelector("[data-naomi-reviews-stars]");
    var distributionTarget = root.querySelector("[data-naomi-reviews-distribution]");
    var listTarget = root.querySelector("[data-naomi-reviews-list]");
    var footer = root.querySelector("[data-naomi-reviews-footer]");
    var activeRating = null;
    var attempts = 0;
    var renderTimer;
    var listHeightTimer;
    var token = cleanToken(root.getAttribute("data-judgeme-public-token") || window.naomiJudgeMePublicToken);
    var shopDomain = root.getAttribute("data-judgeme-shop-domain") || (window.Shopify && window.Shopify.shop) || "";
    var productHandle = root.getAttribute("data-judgeme-product-handle") || productHandleFromUrl();
    var productId = root.getAttribute("data-judgeme-product-id") || "";
    var configuredApiHost = normalizeApiHost(root.getAttribute("data-judgeme-api-host"));
    var api = {
      enabled: Boolean(token && shopDomain && (productHandle || productId) && window.fetch && window.DOMParser),
      hasRendered: false,
      hasMore: false,
      histogram: [],
      average: "",
      loading: false,
      page: 0,
      rating: null,
      requestId: 0,
      reviews: []
    };

    function productHandleFromUrl() {
      var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : "";
    }

    function normalizeApiHost(value) {
      return String(value || "").trim().replace(/\/+$/, "");
    }

    function apiHosts() {
      return unique([
        configuredApiHost,
        "https://judge.me",
        "https://api.judge.me",
        "https://cdn.judge.me"
      ]);
    }

    function reviewsPerPage() {
      var width = root.getBoundingClientRect().width || window.innerWidth || 0;
      return width && width <= 760 ? 3 : 4;
    }

    function widgetUrl(host, rating, page) {
      var params = {
        shop_domain: shopDomain,
        api_token: token,
        handle: productHandle,
        external_id: productId,
        page: page || 1,
        per_page: reviewsPerPage()
      };

      if (rating !== null) params.filter_rating = rating;

      return normalizeApiHost(host) + "/api/v1/widgets/product_review?" + encodeQuery(params);
    }

    function requestWidget(rating, page) {
      var hosts = apiHosts();
      var lastError;

      function tryHost(index) {
        var host = hosts[index];

        if (!host) return Promise.reject(lastError || new Error("Judge.me API host unavailable."));

        return window.fetch(widgetUrl(host, rating, page), {
          credentials: "omit",
          method: "GET"
        }).then(function (response) {
          if (!response.ok) {
            throw new Error("Judge.me Widget API returned " + response.status);
          }

          return response.text();
        }).catch(function (error) {
          lastError = error;
          return tryHost(index + 1);
        });
      }

      return tryHost(0);
    }

    function expectedCount(rating) {
      return totalFromHistogram(api.histogram, rating);
    }

    function apiHasMore(parsedHasMore, addedCount, page) {
      var expected = expectedCount(api.rating);

      if (page > 1 && !addedCount && !parsedHasMore) return false;
      if (parsedHasMore) return true;
      return Boolean(expected && api.reviews.length < expected);
    }

    function stabilizeListHeight() {
      var height = listTarget.getBoundingClientRect().height;

      if (height > 0) {
        listTarget.style.minHeight = Math.ceil(height) + "px";
      }
    }

    function releaseListHeight() {
      window.clearTimeout(listHeightTimer);
      listTarget.style.minHeight = "";
    }

    function scheduleListHeightRelease(delay) {
      window.clearTimeout(listHeightTimer);
      listHeightTimer = window.setTimeout(releaseListHeight, delay);
    }

    function updateDistributionState() {
      Array.prototype.slice.call(distributionTarget.querySelectorAll("[data-naomi-reviews-rating]")).forEach(function (button) {
        var isActive = activeRating === Number(button.getAttribute("data-naomi-reviews-rating"));
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    function writeDistribution(rows) {
      distributionTarget.innerHTML = rows.map(function (row) {
        var isActive = activeRating === row.rating;
        var label = "Show " + row.rating + " star reviews (" + row.count + ")";

        return (
          '<button class="naomi-reviews__bar-row' + (isActive ? " is-active" : "") + '" type="button" aria-label="' + escapeHtml(label) + '" aria-pressed="' + (isActive ? "true" : "false") + '" data-naomi-reviews-rating="' + row.rating + '">' +
            '<span class="naomi-reviews__bar-label">' + row.rating + '</span>' +
            '<span class="naomi-reviews__bar-track"><span class="naomi-reviews__bar-fill" style="width: ' + escapeHtml(row.width) + ';"></span></span>' +
            '<span class="naomi-reviews__bar-count">' + escapeHtml(row.count) + '</span>' +
          '</button>'
        );
      }).join("");
    }

    function writeReviews(reviews, status) {
      listTarget.setAttribute("aria-busy", status && status.loading ? "true" : "false");

      if (!reviews.length) {
        listTarget.innerHTML = status && status.loading
          ? '<div class="naomi-reviews__no-results"><span class="naomi-reviews__loading" role="status" aria-label="Reviews are loading"><span aria-hidden="true"></span><span aria-hidden="true"></span><span aria-hidden="true"></span></span></div>'
          : '<p class="naomi-reviews__no-results">No reviews match this filter.</p>';
        return;
      }

      var anonymousAvatarIndex = 0;

      listTarget.innerHTML = reviews.map(function (review) {
        var date = review.date_display || review.date || "";
        var avatarHtml = "";
        var photoHtml = review.photos && review.photos.length
          ? '<div class="naomi-review__photos">' + review.photos.map(function (photo) {
              return '<img class="naomi-review__photo" src="' + escapeHtml(photo.src) + '" alt="' + escapeHtml(photo.alt) + '" loading="lazy">';
            }).join("") + '</div>'
          : "";

        if (isAnonymousAuthor(review.author)) {
          avatarHtml = '<span class="naomi-review__avatar naomi-review__avatar--logo ' + (anonymousAvatarIndex % 2 ? "is-logo-b" : "is-logo-a") + '" aria-hidden="true"></span>';
          anonymousAvatarIndex += 1;
        } else {
          avatarHtml = '<span class="naomi-review__avatar" aria-hidden="true"><span class="naomi-review__avatar-initials">' + escapeHtml(initialsFromName(review.author)) + '</span></span>';
        }

        return (
          '<article class="naomi-review' + (review.productTitle ? " has-product" : "") + (review.dedupedBody ? " is-deduped" : "") + '">' +
            '<div class="naomi-review__meta">' +
              avatarHtml +
              '<div class="naomi-review__meta-copy">' +
                '<div class="naomi-review__reviewer-line">' +
                  '<div class="naomi-review__author">' + escapeHtml(review.author) + '</div>' +
                  '<span class="naomi-review__verified"' + (review.verified ? "" : " hidden") + '><span class="naomi-review__verified-text">Verified</span></span>' +
                '</div>' +
                (review.productTitle ? '<div class="naomi-review__product">' + escapeHtml(review.productTitle) + '</div>' : "") +
              '</div>' +
            '</div>' +
            '<time class="naomi-review__date">' + escapeHtml(date) + '</time>' +
            '<div class="naomi-review__mobile-rating-date">' +
              '<div class="naomi-review__stars" aria-label="' + review.rating + ' star review">' + starsHtml(review.rating) + '</div>' +
              '<time class="naomi-review__mobile-date">' + escapeHtml(date) + '</time>' +
            '</div>' +
            '<div class="naomi-review__content">' +
              '<div class="naomi-review__stars" aria-label="' + review.rating + ' star review">' + starsHtml(review.rating) + '</div>' +
              (review.title ? '<h3 class="naomi-review__title">' + escapeHtml(review.title) + '</h3>' : "") +
              (review.body ? '<p class="naomi-review__body">' + escapeHtml(review.body) + '</p>' : '<p class="naomi-review__body" hidden></p>') +
              photoHtml +
            '</div>' +
          '</article>'
        );
      }).join("");
    }

    function renderApi() {
      var histogram = api.histogram.length ? api.histogram : readHistogram(source || root);
      var average = api.average || numericText(text(".jdgm-rev-widg__summary-average", source || root)) || numericText(text(".jdgm-link", source || root)) || averageFromHistogram(histogram);

      if (average) {
        averageTarget.textContent = average;
        starsTarget.innerHTML = starsHtml(Number(average));
      }

      if (histogram.length) {
        writeDistribution(histogram);
      }

      writeReviews(api.reviews, { loading: api.loading });
      footer.hidden = api.loading || !api.hasMore;
      view.hidden = false;
      empty.hidden = true;
      api.hasRendered = true;
    }

    function loadApiPage(rating, page, append) {
      var requestId;

      if (!api.enabled) return false;

      requestId = api.requestId + 1;
      api.requestId = requestId;
      api.loading = true;
      api.rating = rating;

      if (!append) {
        api.page = 0;
        api.reviews = [];
        api.hasMore = false;
      }

      renderApi();

      requestWidget(rating, page).then(function (html) {
        var parsed;
        var previousCount;
        var addedCount;

        if (requestId !== api.requestId) return;

        parsed = parseWidget(html, rating);
        if (parsed.average) api.average = parsed.average;
        if (parsed.histogram.length && rating === null) api.histogram = parsed.histogram;
        if (parsed.histogram.length && !api.histogram.length) api.histogram = parsed.histogram;

        previousCount = api.reviews.length;
        api.reviews = append ? mergeReviews(api.reviews, parsed.reviews) : parsed.reviews;
        addedCount = api.reviews.length - previousCount;
        api.page = page;
        api.loading = false;
        api.hasMore = apiHasMore(parsed.hasMore, append ? addedCount : api.reviews.length, page);

        renderApi();
        scheduleListHeightRelease(180);
      }).catch(function (error) {
        if (requestId !== api.requestId) return;

        console.warn("Naomi reviews: Judge.me Widget API failed, falling back to embedded widget.", error);
        api.enabled = false;
        api.loading = false;
        renderSource();
        scheduleListHeightRelease(180);
      });

      return true;
    }

    function sourceReviews() {
      return readReviews(source || root, activeRating);
    }

    function sourceLoadMoreButton() {
      return source && source.querySelector(".jdgm-paginate__load-more");
    }

    function renderSource() {
      var average = source ? numericText(text(".jdgm-rev-widg__summary-average", source)) || numericText(text(".jdgm-link", source)) : "";
      var histogram = source ? readHistogram(source) : [];
      var reviews = sourceReviews();
      var isWaitingForInitialReviews = activeRating === null && !reviews.length;

      if (!average) average = averageFromHistogram(histogram);

      if (activeRating === null) releaseListHeight();

      if ((!average || !histogram.length || isWaitingForInitialReviews) && attempts < 30) {
        attempts += 1;
        window.clearTimeout(renderTimer);
        renderTimer = window.setTimeout(renderSource, 250);
        return;
      }

      if (!average || (!reviews.length && activeRating === null)) {
        root.classList.add("is-fallback");
        if (sourceWrap) sourceWrap.setAttribute("aria-hidden", "false");
        if (empty) empty.hidden = true;
        return;
      }

      averageTarget.textContent = average;
      starsTarget.innerHTML = starsHtml(Number(average));
      writeDistribution(histogram);
      writeReviews(reviews, { loading: false });
      footer.hidden = !sourceLoadMoreButton();
      view.hidden = false;
      empty.hidden = true;
    }

    function scrollToReviews() {
      var target = root.querySelector("#naomi-reviews") || root;
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    root.addEventListener("click", function (event) {
      var target = event.target;
      var writeButton;
      var loadButton;
      var ratingButton;
      var rating;
      var nextRating;

      if (!target || !target.closest) return;

      writeButton = target.closest("[data-naomi-reviews-write]");
      loadButton = target.closest("[data-naomi-reviews-load]");
      ratingButton = target.closest("[data-naomi-reviews-rating]");

      if (ratingButton) {
        event.preventDefault();
        event.stopPropagation();
        rating = Number(ratingButton.getAttribute("data-naomi-reviews-rating"));
        nextRating = activeRating === rating ? null : rating;
        activeRating = nextRating;

        if (activeRating === null) releaseListHeight();
        else {
          stabilizeListHeight();
          scheduleListHeightRelease(900);
        }

        updateDistributionState();

        if (!loadApiPage(activeRating, 1, false)) {
          renderSource();
        }

        return;
      }

      if (writeButton) {
        var sourceWrite = source && source.querySelector(".jdgm-write-rev-link");
        if (sourceWrite) sourceWrite.click();
      }

      if (loadButton) {
        event.preventDefault();

        if (api.enabled && api.hasRendered) {
          loadApiPage(api.rating, api.page + 1, true);
          return;
        }

        if (sourceLoadMoreButton()) {
          sourceLoadMoreButton().click();
          window.setTimeout(renderSource, 700);
        }
      }
    });

    if (!loadApiPage(null, 1, false)) {
      renderSource();
    }

    if (source && window.MutationObserver) {
      new MutationObserver(function () {
        if (api.enabled) return;
        window.clearTimeout(renderTimer);
        renderTimer = window.setTimeout(renderSource, 80);
      }).observe(source, { childList: true, subtree: true, attributes: true });
    }

    root.naomiScrollToReviews = scrollToReviews;
  }

  function isReviewSummaryTrigger(target) {
    var control;

    if (!target || !target.closest) return false;

    if (target.closest("[data-naomi-reviews]")) return false;

    if (target.closest("a[href*='judgeme_product_reviews'], a[href*='naomi-reviews'], .jdgm-preview-badge, .jdgm-prev-badge")) {
      return true;
    }

    control = target.closest("button, [role='button'], [tabindex]");
    return Boolean(control && !control.closest("[data-naomi-reviews]") && control.querySelector(".jdgm-preview-badge, .jdgm-prev-badge"));
  }

  function bindSummaryScroll() {
    if (window.NaomiJudgemeReviewsSummaryBound) return;
    window.NaomiJudgemeReviewsSummaryBound = true;

    document.addEventListener("click", function (event) {
      var root;

      if (!isReviewSummaryTrigger(event.target)) return;

      root = document.querySelector("[data-naomi-reviews]");
      if (!root) return;

      event.preventDefault();
      event.stopPropagation();

      if (root.naomiScrollToReviews) {
        root.naomiScrollToReviews();
      } else {
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, true);
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll("[data-naomi-reviews]")).forEach(initReviews);
    bindSummaryScroll();
  }

  window.NaomiJudgemeReviews = {
    initAll: initAll
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
